import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import "../../styles/GroupBooking.scss";
import React, { useEffect } from "react";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomersByVendorRequest } from "../../redux/Vendors/actions/vendorActions";
import { fetchAllCustomersRequest } from "../../redux/Customers/actions/customerActions";
import DynamicPassengerField from "./DynamicPassengerField";

const CustomerDetailsPage = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      customer: "",
      no_of_adult: 0,
      no_of_child: 0,
      no_of_infant: 0,
      notes: "",
      total_services: 0,
      adults: [
        {
          first_name: "",
          last_name: "",
          age: "",
          phone: "",
          gender_type: "",
          country_code: " ",
          havePassport: false,
          passport_number: "",
          aadhar_number: "",
          nationality: "",
          type: "3",
        },
      ],
      childs: [
        {
          first_name: "",
          last_name: "",
          age: "",
          phone: "",
          gender_type: "",
          country_code: " ",
          havePassport: false,
          passport_number: "",
          aadhar_number: "",
          nationality: "",
          type: "3",
        },
      ],
      infants: [
        {
          first_name: "",
          last_name: "",
          age: "",
          phone: "",
          gender_type: "",
          country_code: " ",
          havePassport: false,
          passport_number: "",
          aadhar_number: "",
          nationality: "",
          type: "3",
        },
      ],
    },
  });
  const formValues = watch();

  const {
    fields: adultField,
    append: adultAppend,
    remove: removeAdult,
  } = useFieldArray({
    control,
    name: "adults",
  });
  const {
    fields: childField,
    append: childAppend,
    remove: removeChild,
  } = useFieldArray({
    control,
    name: "childs",
  });
  const {
    fields: infantField,
    append: infantAppend,
    remove: removeInfant,
  } = useFieldArray({
    control,
    name: "infants",
  });
  useEffect(() => {
    const infantCount = parseInt(formValues.no_of_infant || 0, 10);
    if (infantCount !== infantField.length) {
      if (infantCount > infantField.length) {
        for (let i = infantField.length; i < infantCount; i++) {
          infantAppend({
            first_name: "",
            last_name: "",
            age: "",
            country_code: " ",
            phone: "", // Not mandatory for infants
            gender_type: "",
            nationality: "",
            havePassport: false,
            passport_number: "",
            aadhar_number: "",
            type: "1",
          });
        }
      } else {
        for (let i = infantField.length - 1; i >= infantCount; i--) {
          removeInfant(i);
        }
      }
    }

    const childCount = parseInt(formValues.no_of_child || 0, 10);
    if (childCount !== childField.length) {
      if (childCount > childField.length) {
        for (let i = childField.length; i < childCount; i++) {
          childAppend({
            first_name: "",
            last_name: "",
            age: "",
            country_code: " ",
            phone: "", // Not mandatory for children
            nationality: "",
            gender_type: "",
            havePassport: false,
            passport_number: "",
            aadhar_number: "",
            type: "2",
          });
        }
      } else {
        for (let i = childField.length - 1; i >= childCount; i--) {
          removeChild(i);
        }
      }
    }

    const adultCount = parseInt(formValues.no_of_adult || 0, 10);
    if (adultCount !== adultField.length) {
      if (adultCount > adultField.length) {
        for (let i = adultField.length; i < adultCount; i++) {
          adultAppend({
            first_name: "",
            last_name: "",
            age: "",
            country_code: " ",
            phone: "", // Mandatory for adults
            nationality: "",
            gender_type: "",
            havePassport: false,
            passport_number: "",
            aadhar_number: "",
            type: "3",
          });
        }
      } else {
        for (let i = adultField.length - 1; i >= adultCount; i--) {
          removeAdult(i);
        }
      }
    }
  }, [formValues.no_of_infant, formValues.no_of_child, formValues.no_of_adult]);

  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const { customers: response = {} } = useSelector((state) =>
    user?.user_type === 2 ? state.vendors : state.customers
  );

  const customers = response?.data || [];

  useEffect(() => {
    // dispatch(fetchAllAirportRequest());
    // dispatch(fetchAllServiceRequest());
    if (user?.user_type === 2) {
      dispatch(
        fetchCustomersByVendorRequest({
          pagination_required: false,
          pagesize: 100,
          pageNo: 1,
          vendor_id: user?.vendor_id,
        })
      );
    } else {
      dispatch(fetchAllCustomersRequest());
    }
  }, []);

  const activeCustomers = customers.filter((customer) => {
    if (customer?.status === 1) {
      return {
        customer,
      };
    }
  });

  const customerOptions = activeCustomers.map((customer) => ({
    value: customer.id,
    label: customer.display_name + " - " + customer.customer_serial_no,
  }));

  const nonNegativeValidation = {
    min: {
      value: 0,
      message: "Value cannot be negative",
    },
  };
  const formFields = [
    {
      name: "no_of_adult",
      label: "No of Adults",
      placeholder: "Adult Count",
      type: "number",
      // disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: "no_of_child",
      label: "No of Child",
      placeholder: "Child Count",
      type: "number",
      // disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: "no_of_infant",
      label: "No of Infant",
      placeholder: "Infants Count",
      type: "number",
      // disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: "total_passengers",
      label: "Total Passengers *",
      placeholder: "Calculated total",
      type: "number",
      // disabled: true,
      rules: {
        required: true,
        ...nonNegativeValidation,
        validate: (value) =>
          value > 0 || "please add members to continue booking",
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: "notes",
      label: "Notes",
      placeholder: "Enter any notes",
      type: "text",
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: "total_services",
      label: "No of Service *",
      // disabled:isPorterService? false:true,
      placeholder: "please  add members to continue booking",
      type: "number",
      rules: {
        required: "Required Service is Needed",
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
    },
  ];

  return (
    <Box className="group_container">
      <Card>
        <CardContent>
          <Typography variant="h4" component={"h1"}>
            Group Booking
          </Typography>

          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
            className="group_field"
          >
            <Grid item xs={12}>
              <ControlledTextInputField
                name={"customer"}
                control={control}
                label={"Customer*"}
                options={customerOptions}
                type={"select"}
                placeholder={"Select Customer"}
                // startAdornment={field.icon}

                rules={{ required: "customer is required" }}
                error={!!errors["customer"]}
                helperText={errors["customer"]?.message}
              />
            </Grid>
          </Grid>

          <Box sx={{ marginBlock: "50px" }}>
            <Grid container xs={12} spacing={3}>
              {formFields.map((field, index) => (
                <Grid item xs={12} md={field.md} lg={field.lg} key={index}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    rules={field.rules}
                    type={field.type}
                    label={field.label}
                    disabled={field.disabled}
                    radioOptions={field.radioOptions}
                    placeholder={field.placeholder}
                    options={field.options}
                    getOptionLabel={(option) => option.label}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box sx={{ marginBlock: "50px" }}>
            {adultField.map((item, index) => (
              <DynamicPassengerField
                key={item.id} 
                index={index}
                name="Adults"
                data={item} 
              
              />
            ))}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CustomerDetailsPage;
